module.exports = __webpack_public_path__ + "static/menu-men.6840b46c.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/Nav/menu-men.png
// module id = 1140
// module chunks = 231608221292675